import React from 'react';
import styled from 'styled-components';
import * as CommonComponents from '@prezi/common-components';
import { documentAccessOptions } from '../../__stories__/mocks';
import { Dumb as Atoms } from '../../atoms';
import { Dumb as Molecules } from '../../molecules';
const EntityDisplayContainer = styled(Atoms.RowGrid).withConfig({
  displayName: "DocumentAccess__EntityDisplayContainer",
  componentId: "dyiwwj-0"
})(["padding-left:6px;&&&{row-gap:6px;}"]);
export default (() => React.createElement(Atoms.RowGrid, null, React.createElement(Atoms.SectionHeader, null, "Individual Access"), React.createElement(EntityDisplayContainer, null, React.createElement(Molecules.TeamDisplay, null), React.createElement(Atoms.ColumnAutoMin, null, React.createElement(CommonComponents.UserDisplay, {
  firstName: "Bobby",
  lastName: "Marley",
  caption: "bobby.marley@example.com"
}), React.createElement(Atoms.DocumentAccessSelect, {
  accessOptions: documentAccessOptions,
  currentAccessValue: documentAccessOptions[0].value
})))));